import WebConfig from 'middlewares/WebConfig';
import store from "../index";

const webApiDownloadFile = (url: string, fileNameOverride: string = null) => {
  if (!url.startsWith(WebConfig.webApiRoot)) {
    let urlBuilder = WebConfig.webApiRoot;
    
    if (!url.startsWith("/")) {
      urlBuilder += "/"
    }

    urlBuilder += url;
    url = urlBuilder;
  }

  fetch(url, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${store.getState().user.profile.token}`,
      },
    credentials: "include",
  })
  .then(async response => {    
    let filename: string = fileNameOverride ?? "downloaded-file.txt";
    
    if (!fileNameOverride) {
      const contentDisposition = response.headers.get("Content-Disposition");

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+?)"?$/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }
    }

    const blob = await response.blob();

    const objectUrl: string = window.URL.createObjectURL(blob);
    const link: HTMLAnchorElement = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(objectUrl);
  });

};

export default webApiDownloadFile;